"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NAME = exports.rule = void 0;
const GenericValidator_1 = require("./GenericValidator");
/**
 * Checks that the value retrieved at the specific path is exactly the specified value.
 *
 * Configuration:
 * * type: 'EXACT-VALUE'
 * * path: 'path.to.the.value.to.evaluate'
 * * value: 'value.to.be.enforced'
 */
exports.rule = (config) => new GenericValidator_1.GenericValidator(config, (value) => value === config.value, `Value of '%s' must be '${config.value}'`);
exports.NAME = 'EXACT_VALUE';
//# sourceMappingURL=ExactValueRule.js.map